import React from 'react';
import { Globe, MessageSquare, Zap, Shield, Handshake, Award, ArrowRight } from 'lucide-react';
import { whyChooseUs } from '../../data/mock';

const iconMap = {
  Globe: Globe,
  MessageSquare: MessageSquare,
  Zap: Zap,
  Shield: Shield,
  Handshake: Handshake,
  Award: Award
};

export const WhyUsSection = () => {
  return (
    <section id="why-us" className="py-24 bg-[#1e3a5f]">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        {/* Section Header */}
        <div className="text-center max-w-3xl mx-auto mb-16">
          <span className="text-[#f26522] font-semibold text-sm tracking-wider uppercase">
            Why Choose Us
          </span>
          <h2 className="mt-3 text-3xl sm:text-4xl font-bold text-white leading-tight">
            Your Success Is Our Priority
          </h2>
          <p className="mt-4 text-lg text-white/70">
            We combine India's cost advantage with world-class quality and communication standards.
          </p>
        </div>

        {/* Features Grid */}
        <div className="grid sm:grid-cols-2 lg:grid-cols-3 gap-6">
          {whyChooseUs.map((item, i) => {
            const Icon = iconMap[item.icon] || Globe;
            return (
              <div
                key={i}
                className="group p-6 rounded-2xl bg-white/5 border border-white/10 hover:bg-white/10 hover:border-[#f26522]/50 transition-all duration-300"
              >
                <div className="w-12 h-12 rounded-xl bg-[#f26522] flex items-center justify-center mb-4">
                  <Icon className="w-6 h-6 text-white" />
                </div>
                <h3 className="text-lg font-semibold text-white mb-2">
                  {item.title}
                </h3>
                <p className="text-white/70 text-sm leading-relaxed">
                  {item.description}
                </p>
              </div>
            );
          })}
        </div>

        {/* CTA */}
        <div className="text-center mt-12">
          <button
            onClick={() => document.querySelector('#contact')?.scrollIntoView({ behavior: 'smooth' })}
            className="inline-flex items-center px-8 py-4 bg-[#f26522] text-white font-medium rounded-xl hover:bg-[#d95a1b] transition-all hover:shadow-lg hover:shadow-[#f26522]/30"
          >
            Partner With Us
            <ArrowRight className="ml-2 w-5 h-5" />
          </button>
        </div>
      </div>
    </section>
  );
};
